import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-browser-info',
    templateUrl: './browser-info.component.html',
    styleUrls: ['./browser-info.component.scss'],
    imports: [TranslatePipe]
})
export class BrowserInfoComponent {

  constructor() { }

}
